import { render, staticRenderFns } from "./yewulayunzhanbi.vue?vue&type=template&id=f994f24e&scoped=true&"
import script from "./yewulayunzhanbi.vue?vue&type=script&lang=js&"
export * from "./yewulayunzhanbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f994f24e",
  null
  
)

export default component.exports